<template>
    <div id="footer-section" class="d-flex">
        <p class="terms-text">
            Ao clicar em enviar, você confirma que leu e concorda com as

            <span class="footer-link text-underline" @click="openTermsModal = true">
                políticas de privacidade e termos de uso
            </span>
        </p>
        <div class="d-flex">
            <button class="btn-send text-uppercase" @click="sendForm">Enviar</button>
        </div>
        <span class="missing-fields-msg" v-if="missingFields"
            >Preencha os campos obrigatórios!</span
        >

        <Modal v-model="openPrivacyModal" class="small">
            <div class="rules-modal d-flex">
                <div class="rules-modal-header d-flex">
                    <i class="icon-cr icon-logo-header-cr" />
                    <div class="v-divider" />
                    <span class="logo-text">Termos de Uso</span>
                </div>
                <div class="rules-modal-content d-flex">
                    <span class="rules-modal-title text-center">Regras para o comentário:</span>
                    <div class="rules-modal-text">
                        <p>Você não deve:</p>
                        <ul>
                            <li>Fazer comentários ofensivos;</li>
                            <li>Citar o nome de marcas;</li>
                        </ul>
                        <p>
                            Nos nós reservamos no direito de excluir avaliações que descumpram essas
                            regras.
                        </p>
                    </div>
                </div>
                <button class="btn btn-close-modal bg-default-5" @click="openPrivacyModal = false">
                    Fechar
                </button>
            </div>
        </Modal>
        <Modal v-model="openTermsModal" class="small">
            <div class="rules-modal d-flex">
                <div class="rules-modal-header d-flex">
                    <i class="icon-cr icon-logo-header-cr" />
                    <div class="v-divider" />
                    <span class="logo-text">Painel de Avaliações</span>
                </div>
                <div class="rules-modal-content d-flex">
                    <span class="rules-modal-title text-center">Termos de Uso</span>
                    <div
                        class="rules-modal-text"
                        :style="{ overflowY: 'scroll', maxHeight: '500px' }"
                    >
                        <p>
                            Os presentes Termos e Condições de uso tem como finalidade regular a
                            utilização do serviço de avaliações de produtos da Chico Rei e define-se
                            por um acordo legal entre a CR Minas Comércio Eletrônico e a pessoa
                            física ou jurídica, aqui referida como CLIENTE.
                        </p>
                        <p>1. Definição</p>
                        <p>
                            Esta funcionalidade permite ao CLIENTE avaliar produtos adquiridos no
                            e-commerce da Chico Rei (www.chicorei.com), publicando suas opiniões.
                        </p>
                        <p>
                            A opinião do CLIENTE será autenticada pela Chico Rei e posteriormente
                            divulgada no site www.chicorei.com.
                        </p>
                        <p>2. Funcionamento</p>
                        <p>
                            Após receber o(s) produto(s), adquirido(s) em www.chicorei.com,
                            enviaremos um e-mail ao CLIENTE com link para avaliar o(s) produto(s).
                            Este procedimento é automatizado e integrado via API.
                        </p>
                        <p>
                            Para realizar a avaliação do(s) produto(s), o CLIENTE deve aceitar estes
                            termos e condições de uso.
                        </p>
                        <p>3. Informações do CLIENTE que a Chico Rei receberá</p>
                        <p>
                            A Chico Rei poderá receber do CLIENTE o nome completo, e-mail, quais os
                            produtos foram adquiridos e, a critério do próprio cliente, suas imagens
                            ou de terceiros.
                        </p>
                        <p>
                            3.1 A Chico Rei se compromete a não receber, armazenar ou coletar dados
                            sensíveis do Cliente, a menos que sejam fornecidos voluntariamente pelo
                            próprio Cliente. Nos reservamos ao direito de excluir a avaliação
                            realizada pelo CLIENTE neste caso.
                        </p>
                        <p>
                            3.1.1 São dados sensíveis os dados pessoais ligados à origem racial ou
                            étnica, convicção religiosa, opinião política, filiação a sindicato ou à
                            organização de caráter religioso, filosófico ou político, dado referente
                            à saúde ou à vida sexual, dado genético ou biométrico, quando vinculado
                            a um indivíduo, ou qualquer dado que, quando combinado com outras
                            informações, possa inferir um dado pessoal sensível.
                        </p>
                        <p>
                            3.2 Os dados pessoais coletados no sistema de avaliações não serão
                            destinados ao envio de e-mail marketing pela Chico Rei.
                        </p>
                        <p>4. Autorizações</p>
                        <p>
                            Ao concordar com estes termos e condições de uso e responder ao e-mail
                            com a avaliação do produto adquirido, o CLIENTE autoriza a Chico Rei a
                            validar a avaliação e divulgá-la de forma pública no site da Chico Rei
                            (www.chicorei.com) e em pesquisas do Google, bem como divulgação de seu
                            nome e imagem, que conterá o primeiro nome e a primeira letra do
                            sobrenome.
                        </p>
                        <p>
                            4.1 Não serão divulgados dados pessoais do Cliente, como endereço,
                            documentos pessoais, e-mail, telefone de contato, redes sociais, dentre
                            outros.
                        </p>
                        <p>5. Limitações da utilização</p>
                        <p>
                            5.1 O CLIENTE não poderá publicar conteúdo ofensivo, dados pessoais
                            próprios ou de terceiros nem nomes de concorrentes.
                        </p>
                        <p>5.2 A nota deverá ser limitada ao produto adquirido pelo CLIENTE.</p>
                        <p>
                            5.3 Nos reservamos ao direito de bloquear, cancelar, excluir ou limitar
                            avaliações do CLIENTE, caso seja verificado qualquer tipo de fraude,
                            descumprimento destes termos e/ou dispositivo legal.
                        </p>
                        <p>
                            5.4 O CLIENTE é inteiramente responsável por todo o conteúdo enviado ao
                            assumir as responsabilidades pelos termos utilizados em suas avaliações
                            nesta plataforma.
                        </p>
                        <p>6. Proteção de dados</p>
                        <p>
                            6.1 As informações coletadas somente serão compartilhadas quando forem
                            necessárias: (i) para prestação adequada dos serviços objeto de suas
                            atividades com empresas parceiras; (ii) proteção em caso de conflito;
                            (iii) mediante decisão judicial ou requisição de autoridade competente;
                            (iv) com empresas provedoras de infraestrutura tecnológica e
                            operacional, como empresas intermediadoras de pagamento e provedoras de
                            serviço de armazenamento de informações.
                        </p>
                        <p>
                            6.2 Todos os dados coletados são salvos com o devido cuidado para
                            processamento conforme autorização do titular ou demais casos previstos
                            em lei.
                        </p>
                        <p>
                            6.3 A Política de privacidade da Chico Rei é parte integrante dos termos
                            de uso desta plataforma:
                            https://chicorei.com/central-de-ajuda/#reamaze#0#/kb/politica-de-privacidade
                        </p>
                        <p>7. Disposições gerais</p>
                        <p>7.1 Contato com o encarregado da proteção de dados</p>
                        <p>
                            O encarregado da proteção de dados é o responsável escolhido pela Chico
                            Rei para atuar como canal de comunicação entre o controlador, os
                            titulares dos dados e a Autoridade Nacional de Proteção de Dados (ANPD),
                            quando ela for formalizada. Qualquer dúvida poderá ser encaminhada para
                            o e-mail contato@chicorei.com.br
                        </p>
                        <p>7.2 Legislação e foro</p>
                        <p>
                            Esta política será regida, interpretada e executada de acordo com as
                            Leis da República Federativa do Brasil, especialmente a Lei nº
                            13.709/2018, independentemente das Leis de outros estados ou países,
                            sendo competente o foro de domicílio do Cliente para dirimir qualquer
                            dúvida decorrente deste documento.
                        </p>
                    </div>
                </div>
                <button class="btn btn-close-modal bg-default-5" @click="openTermsModal = false">
                    Fechar
                </button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import Modal from '../../common/container/Modal.vue';

    export default {
        name: 'FooterSection',
        props: {
            missingFields: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                openPrivacyModal: false,
                openTermsModal: false,
                terms: '',
            };
        },
        components: { Modal },

        methods: {
            sendForm() {
                this.$emit('handle-form');
            },
        },
    };
</script>
